import React, { useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import PropTypes from "prop-types";

import { Button, Typography, Dialog, DialogActions, DialogContent } from "@mui/material";

function CropModal({ imageSrc, onCropComplete, onClose }) {
  const cropperRef = useRef();

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    const canvas = cropper.getCroppedCanvas();
    const croppedImage = canvas.toDataURL();
    onCropComplete(croppedImage);
    onClose();
  };

  return (
    <Dialog open onClose={onClose} maxWidth={false} PaperProps={{ sx: { width: 520 } }}>
      <DialogContent sx={{ backgroundColor: "#fafafa", p: 2 }}>
        <Typography variant="h6" mb={2}>
          Cắt ảnh
        </Typography>
        <Cropper
          src={imageSrc}
          style={{ height: 400, width: "100%" }}
          aspectRatio={NaN}
          guides
          ref={cropperRef}
          viewMode={1}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", p: 2 }}>
        <Button variant="outlined" color="error" onClick={onClose}>
          Hủy
        </Button>
        <Button variant="contained" color="primary" onClick={handleCrop}>
          Cắt ảnh
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CropModal.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  onCropComplete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CropModal;
